<template>
  <div class="body">
    <divider/>
    <div>
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">基本信息
      </div>
      <table class="gridtable" style="width: 100%" cellpadding="0" cellspacing="0">
        <tbody>
        <tr>
          <td class="tableLabel">编号</td>
          <td class="tdContent">{{productions.no}}</td>
          <td class="tableLabel">名称</td>
          <td class="tdContent">{{productions.productName}}</td>
          <td class="tableLabel">状态</td>
          <td class="tdContent">{{productions.status}}</td>
        </tr>
        <tr>
          <td class="tableLabel">客户</td>
          <td class="tdContent">{{productions.customerName}}</td>
          <td class="tableLabel">制单人</td>
          <td class="tdContent">{{productions.creatorName}}</td>
          <td class="tableLabel">制单时间</td>
          <td class="tdContent">{{productions.createTime}}</td>
        </tr>
        <tr>
          <td class="tableLabel">备注</td>
          <td class="tdContent" colspan="5">{{productions.note}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div>
      <div
          style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
        附件
      </div>
      <el-table ref="payData1" border :data="productions.attachments">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column prop="fileName" align="left" label="附件描述" show-overflow-tooltip/>
        >
      </el-table>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import constant from "@/util/constant";

  export default {
    name: "SalesOrderPreview",
    components: {HandleDetail},
    props: {
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        billId: "",
        billType: "",
        sequId: "",
        constant,
        deliveryPlace: "", // 收货地址
        nodeId: "",
        isHidden: false,
        productions: {},
      };
    },
    watch: {
      $route: {
        immediate: true,
        handler(val) {
          if (val.query.billId) {
            this.billId = val.query.billId;
            this.billType = val.query.billType;
            this.sequId = val.query.sequId;
            this.getData(val.query.billId);
            this.getNodeValue();
          }
        },
      },
      params: {
        handler() {
          this.doApprove();
        },
      },
    },
    methods: {
      getData() {
        this.$emit("loading-status", {"loading": true});
        this.$http
            .get("basic", `productApplications/${this.billId}`)
            .then(resp => {
              this.$emit("loading-status", {"loading": false});
              this.productions = resp.data;
            });
      },

      // 下载
      downLoad(row) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.filePath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      getNodeValue() {
        let params = {
          billType: this.billType,
          billId: this.billId,
          sequId: this.sequId,
        };
        this.$http.get("basic", "applications/approve", params).then((resp) => {
          this.nodeId = resp.data.nodeId;
        });
      },

      doApprove() {
        let billParam = [];
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          billParam: JSON.stringify(billParam),
        };
        this.$emit("loading-status", {loading: true});
        this.$http
            .post("basic", "applications/doApprove", params)
            .then((resp) => {
              this.$emit("loading-status", {loading: false});
              if (resp.success) {
                this.$message.success("保存成功");
                // if (["regionManager", "fiApprove", "GeneralManager"].includes(this.nodeId)) {
                //   this.updateHandle();
                // }
                // 关闭标签
                this.$bus.$emit("closeTag", this.$route);
                this.$router.push({
                  path: "/workFlow/ProductionApplication",
                });
              }
            })
            .catch(() => {

              this.$emit("loading-status", {loading: false});
            });
      },
    },
  };
</script>
<style lang="scss">
.body {
  .el-button + .el-button {
    margin-left: 0;
  }

  .el-tabs--border-card > .el-tabs__content {
    padding: 10px;
  }

  .body-btn {
    margin-bottom: 2px;
    margin-right: 2px;
  }

  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border-width: 1px;
    border-color: #dddddd;
    border-collapse: collapse;
    width: 100%;
  }

  table.gridtable th {
    text-align: left;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #dddddd;
    background-color: #D1E6F5;
  }

  table.gridtable td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #dddddd;
  }

  .tableLabel {
    width: 10%;
    text-align: right;
    background-color: #D1E6F5;
  }
}
</style>
